import React from 'react';
import { SectionContentTitleTypes } from './SectionContentTitleTypes';

export const SectionContentTitle = ({
  RenderAs = 'h4',
  children,
}: SectionContentTitleTypes.ISectionTitle) => {
  return (
    <RenderAs className={`sectionContentTitle is-${RenderAs}`}>
      {children}
    </RenderAs>
  );
};
